import React from "react";
import Footer from "../Footer";
import Navbar from "../Navbar";
import image1 from "../../assets/image1.jpg";

const CancellationRefundPolicy: React.FC = () => {
  const policySections = [
    {
      title: `Cancellation & Refund Policy – ${import.meta.env.VITE_COMPANY_NAME}`,
      content: `At ${import.meta.env.VITE_COMPANY_NAME}, operated by ${import.meta.env.VITE_COMPANY_NBFC}, we value your trust and are committed to maintaining a transparent and customer-friendly lending experience. This policy outlines our approach towards loan cancellations and refunds for borrowers using our platform.`,
    },
    {
      title: "1. Pre-Disbursement Cancellation",
      content: `If you change your mind before the loan amount is disbursed, you may cancel your approved application at any time without incurring any additional charges or penalties.`,
    },
    {
      title: "2. Post-Disbursement Cancellation",
      content: `If the loan amount has already been credited to your account, you may still request cancellation within 24 hours of disbursement by returning the entire principal amount to ${import.meta.env.VITE_COMPANY_NAME}. Once repayment confirmation is received, your loan will be marked as cancelled in our system.`,
    },
    {
      title: "3. Refund of Excess Payments",
      content: `Any overpayments made towards your loan account will be reconciled and refunded within 5–7 working days after review. Refunds are processed electronically to the original payment source used for repayment.`,
    },
    {
      title: "4. Processing & Timelines",
      list: [
        "Refunds are initiated only after internal verification and reconciliation.",
        "The timeline for refund reflection depends on your bank or payment gateway policy.",
        "Refund confirmation will be communicated via email/SMS registered with the company.",
      ],
    },
    {
      title: "5. Exceptions",
      list: [
        "Loans once disbursed cannot be cancelled beyond 24 hours of credit.",
        "Interest, processing fees, or service charges are non-refundable once the loan has been activated.",
        "Duplicate transactions or technical payment errors will be refunded after due verification.",
      ],
    },
    {
      title: "6. Contact & Resolution",
      content: `If you wish to raise a cancellation or refund request, please contact our support team at your registered email or through the support channels mentioned on our website. All valid refund or cancellation claims will be processed within the regulatory timelines.`,
    },
    {
      title: "Acknowledgment",
      content: `By availing our services, you acknowledge that you have read, understood, and agreed to this Cancellation & Refund Policy. Thank you for choosing ${import.meta.env.VITE_COMPANY_NAME} — your reliable partner for transparent and responsible financial services.`,
    },
  ];

  return (
    <div className="min-w-screen bg-[#141237]">
      <div className="flex w-full flex-col items-center justify-center gap-12 px-4 py-16">
        <Navbar />

        {/* Hero Section */}
        <section className="relative text-center text-white py-16 rounded-xl shadow-lg px-6 md:px-12 overflow-hidden w-full max-w-4xl bg-[#F26622]/10">
          <img
            src={image1}
            alt="Cancellation and Refund Policy"
            className="absolute inset-0 w-full h-full object-cover opacity-25"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#141237]/80 via-[#FF2D55]/20 to-[#141237]/80 rounded-xl"></div>
          <div className="relative z-10">
            <h1 className="text-4xl sm:text-5xl font-bold mb-4 drop-shadow-lg">
              Cancellation & Refund Policy
            </h1>
            <p className="text-lg sm:text-xl max-w-3xl mx-auto leading-relaxed drop-shadow-md mt-4">
              At <span className="font-semibold">{import.meta.env.VITE_COMPANY_NAME}</span>, operated by{" "}
              <span className="font-semibold">{import.meta.env.VITE_COMPANY_NBFC}</span>, we strive to maintain transparency and fairness in all customer transactions.
            </p>
          </div>
        </section>

        {/* Policy Content */}
        <div className="max-w-4xl w-full mx-auto p-8 bg-white rounded-xl shadow-md text-gray-800 space-y-6">
          {policySections.map((section, idx) => (
            <div key={idx} className="space-y-2">
              <h2 className="text-2xl font-semibold text-[#FF2D55]">{section.title}</h2>
              {section.content && <p>{section.content}</p>}
              {section.list && (
                <ul className="list-disc list-inside ml-4 space-y-1">
                  {section.list.map((li, i) => (
                    <li key={i}>{li}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default CancellationRefundPolicy;
